import { useEffect, useState, useRef } from "react";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import SvgIcon from "@mui/material/SvgIcon";
import "./ScanModal.scss";
import ProgressBar from "./ProgressBar";
import styled from "styled-components";
import AlertModal from "./AlertModal";
import { useSelector } from "react-redux";
import { rootReducer } from "../store/store";
type AuthState = ReturnType<typeof rootReducer>;

interface ModalProps {
  onClose: () => void;
  onClick: () => void;
  onDirectClick: () => void;
  offDirectClick: () => void;
}
interface ProgressProps {
  width: number;
}

const alertInfoType = {
  alertShow: false,
  title: '',
  content: ''
}

const ProgressBarContainer = styled.div`
  width: 100%;
  max-width: 100%;
  height: 25px;
  background: var(--kiosk-gray-50, #f6f7fb);
  box-shadow: 6px 6px 20px 0px rgba(0, 0, 0, 0.2) inset;
  border-radius: 12px;
  font-weight: 600;
  font-size: 0.8rem;
  margin-top: 0px;
  overflow: hidden;
`;

const Progress = styled.div<ProgressProps>`
  width: ${(props) => props.width}%;
  height: 100%;
  max-width: 100%;
  padding: 0;
  text-align: center;
  background: var(
    --kiosk-primary-g,
    linear-gradient(180deg, #3e83f1 0%, #4667d9 100%)
  );
  color: #111;
  transition: width 1s; /* 진행 시 애니메이션 설정 */
`;
const Scanscan: React.FC<ModalProps> = ({
  onClose,
  offDirectClick,
  onClick,
  onDirectClick,
}) => {
  const [progress, setProgress] = useState(0);
  const [scaning, setScaning] = useState<boolean>(false);
  const [alertInfo, setAlertInfo] = useState(alertInfoType);
  const [isMotorType, setIsMotorType] = useState<boolean>();
  const kioskInfo = useSelector((state: AuthState) => state.store.kioskInfo);

  useEffect(() => {

    setIsMotorType(kioskInfo?.data?.licenseScannerType === "MOTOR");

    const inputElement: HTMLInputElement | null = document.getElementById(
      "licenseScanWaitStatus"
    ) as HTMLInputElement | null;

    if (inputElement?.value === "true" && progress < 100) {
      setScaning(true);
    }

    if (inputElement?.value === "false") {
      setScaning(false);
      setProgress(0);
    }

    let interval: NodeJS.Timeout; // 타이머 변수

    interval = setInterval(() => {
      // 면허 스캔 리턴이 오는 경우
      if (inputElement?.value === "false" && scaning) {
        setScaning(false);
        clearInterval(interval);
        clearTimeout(timeout);
        onClose();
        offDirectClick();
        return false;
      }

      if (inputElement?.value === "true" && progress === 100) {
        setScaning(false);
        setProgress(0)
        const licenseScanReturnMsg: HTMLInputElement | null =
          document.getElementById(
            "licenseScanReturnMsg"
          ) as HTMLInputElement | null;
        clearInterval(interval);
        clearTimeout(timeout);

        setAlertInfo(prev => ({
          alertShow: true,
          title: '면허 스캔 실패',
          content: licenseScanReturnMsg?.value || '면허 스캔에 실패했습니다.<br/> 다시 시도해주세요.'
        }))
        if (inputElement !== null) {
          inputElement.value = "false";
        }
      }

      if (progress < 100) {
        setProgress((prevProgress) => prevProgress + 1);
      }
    }, 300); // 0.3초마다 진행

    // 최대 30초로 제한
    const timeout = setTimeout(() => {
      clearInterval(interval); // 30초 후에 타이머 해제
    }, 30000);



    return () => {
      clearInterval(interval);
      clearTimeout(timeout); // 컴포넌트 언마운트 시 타이머 정리
    };
  }, [progress]);
  return (
    <>
      <div className="scan-overlay">
        <div className="scan-container">
          <div className="scan-content">
            <div className="scan-title">
              <span>운전면허증 스캔</span>
              <SvgIcon
                component={CloseOutlinedIcon}
                style={{
                  fontSize: "3em",
                  position: "absolute",
                  left: "90%",
                  color: "#71798C",
                }}
                onClick={onClose}
              ></SvgIcon>
            </div>
            {
              isMotorType ? (
                <p>
                  스캔하기 버튼을 누른 후
                  <br /> 운전면허증 앞면이 위를 향하도록 스캐너에 넣어주세요.
                </p>
              ) : (
                <p>
                  스캔하기 버튼을 누른 후
                  <br /> 운전면허증 앞면이 아래를 향하도록 스캐너에 올려주세요.
                  <br /> <span style={{ fontWeight: 600 }}>면허증 재스캔시에는 면허증을 다시 올렸다 놓아주세요.</span>
                </p>
              )
            }
            
          </div>
          <div className="scan-img-wrap">
            {
              isMotorType ? (
                <img src="/img/scaning_motor.png"></img>
                // <img src="/img/nature-logo.svg"></img>
              ) : (
                <img src="/img/scaning_quantum.gif"></img>
              )
            }
          </div>
          <div className="scan-btn-wrap">
            <div className="btn-wrap">
              <button
                style={{ fontSize: "1.8em", border: "none" }}
                onClick={() => {
                  setScaning(true)
                  onClick()
                }
                }
              >
                스캔하기
              </button>
            </div>

            <div className="btn-wrap">
              <button
                style={{
                  fontSize: "1.8em",
                  border: "none",
                  color: "#3e83f1",
                  background: "white",
                }}
                onClick={onDirectClick}
              >
                직접 입력하기
              </button>
            </div>
          </div>
        </div>
      </div>
      {scaning && (
        <div className="progress-wrap">
          <span>운전면허증 스캔이 진행중입니다.</span>
          <ProgressBarContainer>
            <Progress width={progress} style={{ marginTop: "0" }}></Progress>
          </ProgressBarContainer>
        </div>
      )}
      {alertInfo.alertShow && (
        <AlertModal
          onClose={() => {
            setAlertInfo(prev => ({
              ...prev,
              alertShow: false
            }))
          }}
          title={alertInfo.title}
          content={alertInfo.content}
        ></AlertModal>
      )}
    </>
  );
};

export default Scanscan;
